import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// import CommonVideoCard from '../CommonVideoCard/CommonVideoCard';
// external-global styles must be imported in your JS.
import Carousel from 'nuka-carousel';
import leftArr from './assets/v4-left-arr.png';
import rightArr from './assets/v4-right-arr.png';
import s from './CardCarouselFeatured.css';

class CardCarouselFeatured extends Component {
  static propTypes = {
    children: PropTypes.array,
    title: PropTypes.string
  };

  render() {
    const { children, title, withContent, slidesToShow } = this.props;

    const assets = {
      leftArr: leftArr,
      rightArr: rightArr
    };

    return (
      <Fragment>
        {title && (
          <div className={s.title_container}>
            <h1>{title}</h1>
          </div>
        )}
        <div className={`${s.main_container} ${withContent ? s.content : ''}`}>
          <Carousel
            renderBottomCenterControls={() => {
              return false;
            }}
            withoutControls={false}
            slidesToShow={slidesToShow}
            cellSpacing={10}
            initialSlideHeight={300}
            // heightMode={300}
            slidesToScroll={slidesToShow}
            // renderTopCenterControls={({ currentSlide, slideCount }) => (
            //   <div>Slide: {currentSlide + ' ' + slideCount}</div>
            // )}
            renderCenterLeftControls={({
              previousSlide,
              slideCount,
              currentSlide
            }) => {
              if (slideCount <= slidesToShow) {
                return (
                  <button onClick={previousSlide} className={s.arrowHide}>
                    <img alt="#" src={assets.leftArr} />
                  </button>
                );
              }
              if (currentSlide === 0) {
                return (
                  <button onClick={previousSlide} className={s.arrowHide}>
                    <img alt="#" src={assets.leftArr} />
                  </button>
                );
              } else {
                return (
                  <button onClick={previousSlide} className={s.arrow}>
                    <img alt="#" src={assets.leftArr} />
                  </button>
                );
              }
            }}
            renderCenterRightControls={({
              nextSlide,
              slideCount,
              currentSlide
            }) => {
              const newVal = slideCount - slidesToShow;
              if (slideCount <= slidesToShow) {
                return (
                  <button onClick={nextSlide} className={s.arrowHide}>
                    <img alt="#" src={assets.righttArr} />
                  </button>
                );
              }
              if (currentSlide === newVal) {
                return (
                  <button onClick={nextSlide} className={s.arrowHide}>
                    <img alt="#" src={assets.rightArr} />
                  </button>
                );
              } else {
                return (
                  <button onClick={nextSlide} className={s.arrow}>
                    <img alt="#" src={assets.rightArr} />
                  </button>
                );
              }
            }}
          >
            {children}
          </Carousel>
          {/* <div className={s.shadow} /> */}
        </div>
      </Fragment>
    );
  }
}

export default withStyles(s)(CardCarouselFeatured);
